export function setupSingle() {
  if (!document.body.classList.contains("single")) return;

  const imagenes = document.querySelectorAll(".wp-block-image");

  for (const imagen of imagenes) {
    imagen.addEventListener("click", function (e) {
      verImagenZoom(e.currentTarget);
    });
  }

  //sharer mobile
  const sharer_btn = document.querySelector(".entry-sharer__ver_btn");
  if (sharer_btn) {
    sharer_btn.addEventListener("click", function () {
      const padre = this.closest(".entry-sharer");
      padre.classList.toggle("entry-sharer--activo");
    });
  }
}

//ver imagen zoom
export function verImagenZoom(imagen) {
  return;

  const imagen_img = imagen.querySelector("img");

  const modal = document.querySelector(".zoom_imagen_modal");
  const modal_img_cargando = modal.querySelector(
    ".zoom_imagen_modal__body .zoom_imagen_modal__cargando"
  );
  const modal_img = modal.querySelector(
    ".zoom_imagen_modal__body .zoom_imagen_modal__imagen"
  );
  const modal_fc = modal.querySelector(".zoom_imagen_modal__body p");
  const modal_body = document.querySelector(".zoom_imagen_modal__body");
  const modal_cerrar = document.querySelector(".zoom_imagen_modal__cerrar");

  //modal_img.src = imagen_img.dataset.fullUrl;
  var img = new Image();

  var nuevo_src = imagen_img.dataset.fullUrl;
  if (!imagen_img.dataset.fullUrl) nuevo_src = imagen_img.dataset.origFile;
  if (!imagen_img.dataset.origFile) nuevo_src = imagen_img.dataset.largeFile;
  if (!imagen_img.dataset.largeFile) nuevo_src = imagen_img.src;
  img.src = nuevo_src;

  /*img.src = imagen_img.dataset.fullUrl
        ? imagen_img.dataset.fullUrl
        : imagen_img.src;*/
  img.onload = function () {
    var nuevo_src = imagen_img.dataset.fullUrl;
    if (!imagen_img.dataset.fullUrl) nuevo_src = imagen_img.dataset.origFile;
    if (!imagen_img.dataset.origFile) nuevo_src = imagen_img.dataset.largeFile;
    if (!imagen_img.dataset.largeFile) nuevo_src = imagen_img.src;
    modal_img.src = nuevo_src;

    /*modal_img.src = imagen_img.dataset.fullUrl
            ? imagen_img.dataset.fullUrl
            : imagen_img.src;*/
    modal.classList.remove("cargando");
  };

  modal_cerrar.addEventListener("click", function () {
    const modal = document.querySelector(".zoom_imagen_modal");
    modal.classList.remove("abierto");
    modal.classList.remove("cargando");
  });

  modal.classList.add("abierto");
  modal.classList.add("cargando");
}
